import React from "react";
import { Button } from "./ui/button";

/**
 * EmptyState - Reusable empty state for Aurora Geriátrica.
 * Elegant, calm, medical aesthetic.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className = "",
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-16 px-6 text-center bg-slate-50/50 rounded-xl border border-slate-100 ${className}`}
      data-testid="empty-state"
    >
      {Icon && (
        <div className="h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center mb-4 text-slate-400">
          <Icon className="h-8 w-8" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="text-lg font-semibold text-slate-800 mb-2">{title}</h3>
      <p className="text-slate-600 text-sm max-w-sm mb-6">{description}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction} className="bg-slate-800 hover:bg-slate-700">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
